<div class="dialog-header">
  <div class="header-img" [ngClass]="data.partnerCode"></div>

  <div class="header-wrapper">
    <mat-icon> info_outline </mat-icon>
    <div class="header-title">{{ "renewal.tooEarlyRenewal" | translate }}</div>
  </div>
</div>

<div class="dialog-content">
  <div>{{ "renewal.tooEarlyRenewalDesc1" | translate : { "1": desc1 } }}</div>

  <div
    [innerHTML]="'renewal.tooEarlyRenewalDesc2' | translate : { '1': desc2 }"
  ></div>

  <div>{{ "renewal.tooEarlyRenewalDesc3" | translate }}</div>
</div>

<div class="dialog-footer">
  <button mat-dialog-close mat-flat-button class="white-btn">
    {{ "renewal.close" | translate }}
  </button>
  <button
    mat-flat-button
    class="secondary-btn"
    (click)="handleSubmitReminder()"
  >
    {{ "renewal.remindMe" | translate }}
  </button>
</div>
